module.exports = __webpack_public_path__ + "img/edit.cb096137.svg";